import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Box } from '@mui/material'

const PresentationMode = ({ children }) => {
  const classes = useStyles()
  return <Box className={classes.mainBox}>{children}</Box>
}

export default PresentationMode

const useStyles = makeStyles({
  mainBox: {
    position: 'relative',
    height: '100%',
    background: 'white',
    transition: 'transform 0.8s ease',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
})
